import { render } from "./Disabled.vue?vue&type=template&id=28bd4317"
import script from "./Disabled.vue?vue&type=script&lang=ts"
export * from "./Disabled.vue?vue&type=script&lang=ts"
script.render = render

export default script